"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalBlueprint = void 0;
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var OptionalBlueprint;
(function (OptionalBlueprint) {
    var BP_NAMESPACE = 'bp3';
    OptionalBlueprint.Icon = function (_a) {
        var icon = _a.icon, className = _a.className, _b = _a.size, size = _b === void 0 ? 'standard' : _b;
        return React.createElement("span", { className: classnames_1.default(className, getIconClass(icon), BP_NAMESPACE + "-icon-" + size) });
    };
    function getClasses() {
        var names = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            names[_i] = arguments[_i];
        }
        return names.map(function (name) { return BP_NAMESPACE + "-" + lodash_1.default.kebabCase(name); }).join(' ');
    }
    OptionalBlueprint.getClasses = getClasses;
    function getIconClass(iconName) {
        return BP_NAMESPACE + "-icon-" + lodash_1.default.kebabCase(iconName);
    }
    OptionalBlueprint.getIconClass = getIconClass;
})(OptionalBlueprint = exports.OptionalBlueprint || (exports.OptionalBlueprint = {}));
//# sourceMappingURL=OptionalBlueprint.js.map